const TONES = {
  overall: "border-amber-700/60 bg-amber-950/20 text-amber-200",
  rookie: "border-stone-600/60 bg-stone-900/40 text-stone-200",
  veteran: "border-amber-700/60 bg-amber-950/20 text-amber-200",
  legends: "border-red-700/60 bg-red-950/20 text-red-200",
};

export const LeagueBadge = ({ league, label, testId, className = "" }) => {
  const tone = TONES[league] || TONES.overall;
  const text = label || `${String(league || "").charAt(0).toUpperCase()}${String(league || "").slice(1)}`;
  return (
    <span
      data-testid={testId}
      className={`inline-flex items-center rounded-sm border px-2.5 py-1 text-[11px] font-semibold uppercase tracking-[0.18em] ${tone} ${className}`}
    >
      {text}
    </span>
  );
};
